import styled from 'styled-components';

import Picture from '../picture';

import * as Base from './styled.default';

export const Wrapper = styled.div`
  display: block;
  appearance: none;
  border: none;
  margin: 0;
  padding: 1.25rem;
  font-size: inherit;
  position: relative;
  text-align: left;
  background: transparent;
  z-index: 0;
  overflow: hidden;
  user-select: none;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0px 0px 0px 3px ${Styles.color.grey.four};
  }

  ${Styles.desktop`
    flex-direction: column;
  `}
`;

export const Content = styled(Base.Content)`
  flex: 2;
  color: ${Styles.color.black};
  padding: 0;
  text-shadow: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  ${Styles.desktop`
    flex: 1;
    padding: 0.8rem 1.3rem;
  `}
`;

export const StyledPicture = styled(Picture)`
  position: relative;
  flex: 1.2;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  ${Styles.desktop`
    flex: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 0;
  `}
`;

export const Heading = styled(Base.Heading)`
  margin: 0.5rem 0 0.25rem;
  font-size: 1.2rem;
  width: 100%;
  text-transform: none;

  ${Styles.desktop`
    font-size: 1.5rem;
    max-height: 3rem;
    overflow: hidden;
  `}
`;

export const Body = styled(Base.Body)`
  height: auto;
  width: 100%;

  ${Styles.desktop`
    font-size: 0.9375rem;
  `}
`;

export const Footer = styled(Base.Footer)`
  margin-top: 10px;
  align-self: flex-end;
`;

export * from './styled.default';
